export default __webpack_public_path__ + "profile-pic-placeholder.482bfb6ef028a2080a92.png";